export default __webpack_public_path__ + "static/media/globe-icon.d1c41629.svg";